var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.labels),function(p,idx){return _c('tr-text',_vm._b({key:idx,attrs:{"tracker":_vm.tracker},on:{"edit-tr":function($event){return _vm.$emit('edit-tr', $event)}}},'tr-text',p,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }